import { untitledSnapshotName } from '@ipfabric/utils';
import { Fragment, PureComponent } from 'react';

import { Button } from 'components/Button/Button';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';
import { nameChange } from './actions';
import { makeSelectSavingName } from './selectors';

const MAX_LENGTH = 60;

class Name extends PureComponent {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    msg: PropTypes.object,
    onNameChange: PropTypes.func.isRequired,
    savingName: PropTypes.bool.isRequired,
    snapshot: ImmutablePropTypes.map.isRequired,
  };

  state = {
    edit: false,
    nameValue: '',
    lengthError: false,
  };

  componentDidUpdate(prevProps) {
    const { savingName } = this.props;
    if (prevProps.savingName !== savingName && !savingName) {
      this.restoreState();
    }
  }

  getName = () => {
    const { snapshot } = this.props;
    const name = snapshot.get('name');
    return typeof name === 'string' && name.trim().length > 0
      ? name.trim()
      : untitledSnapshotName;
  };

  restoreState = () => {
    this.setState({
      edit: false,
      nameValue: '',
    });
  };

  handleKeyDown = handleEvent((e) => {
    if (e.keyCode === 27) {
      this.restoreState();
    } else if (e.keyCode === 13) {
      this.saveName();
    }
  });

  handleEditChange = handleEvent(() => {
    const { snapshot, canEdit } = this.props;
    if (!this.state.edit && canEdit) {
      this.setState({ edit: true, nameValue: snapshot.get('name') || '' });
    }
  });

  handleNameChange = handleEvent(({ target: { value } }) => {
    this.setState({ nameValue: value });
    if (value.length > MAX_LENGTH) {
      this.setState({ lengthError: true });
    } else if (value.length <= MAX_LENGTH && this.state.lengthError) {
      this.setState({ lengthError: false });
    }
  });

  saveName = handleEvent(() => {
    const { onNameChange, snapshot } = this.props;
    const { nameValue } = this.state;
    if (nameValue.length <= MAX_LENGTH) {
      onNameChange({
        id: snapshot.get('id'),
        previousName: this.getName(),
        name: nameValue,
      });
    }
  });

  render() {
    const { savingName, canEdit, msg } = this.props;
    const { edit, nameValue, lengthError } = this.state;
    return (
      <div
        className={`snapshots-name__wrapper ${!canEdit || edit ? ' snapshots-name__wrapper--edit' : ''}`}
        onClick={this.handleEditChange}
      >
        {edit ? (
          <div>
            <input
              className={`snapshots-name__input form-control pull-left w-full ${lengthError ? 'snapshots-name__input--error' : ''}`}
              value={nameValue}
              onChange={this.handleNameChange}
              onKeyDown={this.handleKeyDown}
              onBlur={this.saveName}
              autoFocus
              disabled={savingName}
            />
            {lengthError ? (
              <div className='snapshots-name__error'>
                {get(msg, 'name.validation.length').replace(
                  '{MAX_LENGTH}',
                  MAX_LENGTH,
                )}
              </div>
            ) : null}
          </div>
        ) : (
          <Fragment>
            <h3 className='snapshots-content-name__heading pull-left'>
              {this.getName()}
            </h3>
            {canEdit && (
              <Button
                variant='tertiary'
                size='xxs'
                icon='fa-pen'
                className='ml-2 mt-1'
              />
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  savingName: makeSelectSavingName(),
});

function mapDispatchToProps(dispatch) {
  return {
    onNameChange: (args) => dispatch(nameChange(args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Name);
